module.exports = __webpack_public_path__ + "img/5-2.53c69500.png";